/**
 * Shallow-equality comparator for `React.memo` that ignores function-typed props.
 *
 * Replacement for the legacy `PureRenderIgnoreFunctions` HOC: callbacks created
 * inline by parents are skipped, so a component is only re-rendered when a
 * non-function prop actually changes by reference.
 *
 * @param prevProps - the previous props
 * @param nextProps - the next props
 * @returns `true` when the non-function props are shallowly equal (skip render)
 */
export const shallowEqualIgnoreFunctions = (prevProps, nextProps) => {
    const prev = excludeFunctions(prevProps);
    const next = excludeFunctions(nextProps);
    const prevKeys = Object.keys(prev);
    const nextKeys = Object.keys(next);
    if (prevKeys.length !== nextKeys.length) {
        return false;
    }
    return prevKeys.every(key => Object.is(prev[key], next[key]));
};
const excludeFunctions = (obj) => {
    const result = {};
    for (const prop in obj) {
        if (typeof obj[prop] !== 'function') {
            result[prop] = obj[prop];
        }
    }
    return result;
};
